import _ from 'lodash';

const getLocale = (state) => _.get(state, 'locales.language', 'en');

export default getLocale;
